export default __webpack_public_path__ + "static/media/evcgClose.e57aafef.jpg";